import styled from 'styled-components';

import { setVh } from 'utils/styles/mixins';
import { colors } from 'utils/styles/theme';

export default styled.div`
  position: fixed;
  top: 0;
  left: 0;

  height: ${setVh(100)};
  width: 100%;

  overflow: hidden;
  background-color: ${colors.white};
  z-index: 10000;
`;
